import { get } from 'svelte/store';
import { getAppConfig } from '../../../common/config/app-config';
import { APP_CONSTANTS } from '../../../common/config/app-constants';
import { httpGetJSON } from '../../../common/services/ajax-services';
import { blogBaseUrl } from '../store/blog_store';

const { datelang, encodedContextPath } = getAppConfig();

export function getBlogCardDetails(blog) {
  const { tags } = blog;
  const data = {
    title: getBlogElementDetails(blog, 'title'),
    subTitle: getBlogElementDetails(blog, 'subTitle'),
    description: getBlogElementDetails(blog, 'description'),
    // image : getImageUrl(blog.image, false),
    tags: tags.map(x =>
      Object.assign(
        {},
        {
          label: getBlogElementDetails(x, 'label'),
          url: getBlogElementDetails(x, 'url'),
        }
      )
    ),
  };
  return data;
}

function getBlogElementDetails(data, key: string) {
  data[key].values.forEach(item => {
    if (item.locale === datelang) {
      key = item.value;
    }
  });
  return key;
}

export function truncateString(str, maxLength) {
  return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
}

export function getBlogDateFormat(date) {
  return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

export async function getRelatedBlogs(blogs) {
  const url = `${encodedContextPath}/${APP_CONSTANTS.GET_RELATED_BLOG_POST}`;
  const body = {
    postIds: blogs,
  };
  const response = await httpGetJSON(url, body, {}, true);
  return response;
}

export function blogClickedAction(catId, postId) {
  window.location.href = get(blogBaseUrl) + '/' + catId + '/' + postId;
}

export function blogArrowClicked(postId) {
  const modifiedUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
  window.location.href = modifiedUrl + '/' + postId;
}

export async function getBlogDataByPagination(catId: string, page: number = 0) {
  const url = APP_CONSTANTS.GET_BLOG_NEXT_POST.replace('{catId}', catId);

  const apiUrl = `${encodedContextPath}/${url}`;

  const body = {
    page: page,
  };
  const response = await httpGetJSON(apiUrl, body, {}, false);
  return response;
}

export function getBlogFilterUrl(catId) {
  if (catId === 'all') {
    return get(blogBaseUrl);
  } else {
    return get(blogBaseUrl) + '/' + catId;
  }
}

/**
 * Extracts the alt text or file name from a given URL.
 *
 * @param {string} url - The URL from which to extract the alt text or file name.
 * @returns {string | null} The extracted part of the URL after the last "/", or null if an error occurs.
 */
export function getBlogImageAltTextFromUrl(url: string): string | null {
  try {
    if (typeof url !== 'string' || url.trim() === '') {
      throw new Error('Invalid URL');
    }

    // Remove query string (anything after '?')
    const urlWithoutQuery = url.split('?')[0];

    // Extract the part after the last '/'
    const lastIndex = urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('/') + 1);

    // Ensure lastIndex is not an empty string
    if (!lastIndex) {
      throw new Error('No valid part found after the last "/"');
    }

    return lastIndex;
  } catch (error) {
    console.error(error.message);
    return null;
  }
}
